import moment from 'moment';
import React, { forwardRef, useState, useRef } from 'react';
import DatePicker from 'react-datepicker';

const CustomInput = forwardRef(
	({ selectedValue, onClick, className, placeholderText, isRange }, ref) => {
		const label = isRange
			? `${selectedValue ? moment(selectedValue).format('MM/DD/YYYY') : placeholderText || ''}`
			: `${placeholderText}${
					selectedValue ? `: ${moment(selectedValue).format('MM/DD/YYYY')}` : ''
				}`;

		return (
			<button className={className} onClick={onClick} ref={ref}>
				<span className="ats-calendar-btn-label">{label}</span>
				<img src="/ats/icons/calendar-icon.svg" alt="" />
			</button>
		);
	}
);

export default function Calendar({ value, placeholder, onChange, isRange }) {
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const startDatePickerRef = useRef(null);
	const endDatePickerRef = useRef(null);

	const handleApply = () => {
		onChange(isRange ? [startDate, endDate] : startDate);
		if (startDatePickerRef.current) {
			startDatePickerRef.current.setOpen(false);
		}
		if (endDatePickerRef.current) {
			endDatePickerRef.current.setOpen(false);
		}
	};

	return (
		<div className={`ats-calendar ${isRange ? 'ats-calendar-range' : ''}`}>
			<DatePicker
				ref={startDatePickerRef}
				selected={startDate}
				onChange={date => {
					setStartDate(date);
				}}
				shouldCloseOnSelect={false}
				startDate={startDate}
				endDate={endDate}
				selectsStart
				customInput={
					<CustomInput
						placeholderText={placeholder}
						className="ats-calendar-btn"
						selectedValue={isRange ? value?.[0] : value}
						isRange={isRange}
					/>
				}>
				<div className="ats-calendar-action-buttons">
					<button
						className="ats-calendar-clear-btn"
						onClick={() => {
							onChange(isRange ? [null, endDate] : null);
							setStartDate(null);
						}}>
						Clear
					</button>
					<button className="ats-calendar-apply-btn" onClick={handleApply}>
						Apply
					</button>
				</div>
			</DatePicker>
			{isRange && (
				<DatePicker
					ref={endDatePickerRef}
					selected={endDate}
					onChange={date => {
						setEndDate(date);
					}}
					shouldCloseOnSelect={false}
					startDate={startDate}
					endDate={endDate}
					selectsEnd
					minDate={startDate}
					customInput={
						<CustomInput
							placeholderText={placeholder}
							className="ats-calendar-btn"
							selectedValue={value?.[1]}
							isRange={isRange}
						/>
					}>
					<div className="ats-calendar-action-buttons">
						<button
							className="ats-calendar-clear-btn"
							onClick={() => {
								onChange(isRange ? [startDate, null] : null);
								setEndDate(null);
							}}>
							Clear
						</button>
						<button className="ats-calendar-apply-btn" onClick={handleApply}>
							Apply
						</button>
					</div>
				</DatePicker>
			)}
		</div>
	);
}
